import React, { Component } from "react";

import styled from "styled-components";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";

// datatable related plugins
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";

import {
  getPaymentFormulas,
  addPaymentFormulas,
  deletePaymentFormulas,
  patchPaymentFormulas,
  getPaymentFormulasForId,
} from "../../store/payment-formula/actions.js";
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import RemoteTable from "../../components/Common/RemoteTable";
import SweetAlert from "react-bootstrap-sweetalert";
import ModifiedMetaTags from '../../components/ModifiedMetaTags/index';

class PaymentFormulas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sizePerPage: 10,
      deleteAlert: null,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    this.props.getPaymentFormulas(this.props.data);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
  }

  handleTableChange = (data) => {
      this.props.getPaymentFormulas(data);
  };

  handleChangeDeleteAlert = data => {
    this.setState({ deleteAlert: data });
  };

  render() {
    const onClickRow = (e, row) => {
      this.props.history.push(`/payment-formulas/${row.id}`);
    };

    const addPaymentFormulas = () => {
      this.props.history.push(`/payment-formulas/add`);
    };

    const legalNameFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => onClickRow(e, row)}>
          {row[label]}
        </LegalNameLink>
      );
    };

    const dateFormatter = (cell, row, label) => {
      return (
        <LegalNameLink onClick={e => onClickRow(e, row)}>
          {row[label].slice(0, 10)}
        </LegalNameLink>
      );
    };

    const actionsFormatter = (cell, row) => {
      const onClickDelete = () => {
        this.handleChangeDeleteAlert({
          title: `Delete "${row.formula}"!`,
          onConfirm: () => {
            this.props.deletePaymentFormulas(row.id, {
              ...this.props.data,
              page:
                this.props.data.results.length === 1 ? 1 : this.props.data.page,
            });
            this.handleChangeDeleteAlert(null);
          },
        });
      };

      return (
        <>
          {this.props.permissions["change_paymentformulamodel"] && (
            <button
              type="button"
              className="btn btn-primary  btn-sm"
              onClick={e => onClickRow(e, row)}
            >
              <i className="mdi mdi-circle-edit-outline d-block font-size-16" />
            </button>
          )}
          {this.props.permissions["delete_paymentformulamodel"] && (
            <button
              type="button"
              className="btn btn-danger btn-sm m-1"
              onClick={onClickDelete}
            >
              <i className="mdi mdi-trash-can d-block font-size-16" />
            </button>
          )}
        </>
      );
    };

    const columns = [
      {
        dataField: "formula",
        text: "Representation",
        sort: true,
        formatter: (cell, row) =>
          legalNameFormatter(cell, row, "formula"),
      },
      {
        dataField: "created_at",
        text: "Created at",
        sort: true,
        formatter: (e, row) => dateFormatter(e, row, "created_at"),
      },
      {
        dataField: "actions",
        text: "Actions",
        sort: false,
        formatter: actionsFormatter,
      },
    ];

    return (
      <>
        {this.props.data !== null && (
          <React.Fragment>
            <div className="page-content">
            <ModifiedMetaTags title="Payment Formulas | Mobihunter" />

              <Container fluid>
                <Breadcrumbs title="Dashboard" breadcrumbItem="Payment Formulas" link="/dashboard" />
                {this.state.deleteAlert && (
                  <SweetAlert
                    showCancel
                    confirmBtnText="Delete"
                    cancelBtnText="Cancel"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle=""
                    title={this.state.deleteAlert.title}
                    onCancel={() => this.handleChangeDeleteAlert(null)}
                    onConfirm={this.state.deleteAlert.onConfirm}
                  >
                    <p>
                      Are you sure want to delete this payment formula?
                    </p>
                  </SweetAlert>
                )}
                <Row>
                  <Col className="col-12">
                    <Card>
                      <CardBody>
                        <RemoteTable
                          onTableChange={this.handleTableChange}
                          columns={columns}
                          data={this.props.data}
                          loading={this.props.loading}
                        >
                          {!!this.props.permissions?.["add_paymentformulamodel"] && (
                              <Button
                                type="button"
                                color="success"
                                className="btn-rounded mb-2 me-2"
                                onClick={() => addPaymentFormulas()}
                              >
                                <i className="mdi mdi-plus me-1" /> Add payment
                                formula
                              </Button>
                            )}
                        </RemoteTable>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </React.Fragment>
        )}
      </>
    );
  }
}

const LegalNameLink = styled.div`
  transition-duration: 0.1s;
  &:hover {
    color: rgb(85, 110, 230);
    transition-duration: 0.1s;
  }
`;

PaymentFormulas.propTypes = {
  data: PropTypes.any,
  loading: PropTypes.bool,
  history: PropTypes.any,
  payment_formula: PropTypes.any,
  permissions: PropTypes.any,
  isError: PropTypes.bool,
  getPaymentFormulas: PropTypes.func,
  deletePaymentFormulas: PropTypes.func,
};

const mapStateToProps = state => ({
  data: state.PaymentFormulas.data,
  loading: state.PaymentFormulas.loading,
  permissions: state.User.permissions,
  isError: state.PaymentFormulas.isError,
});

export default connect(mapStateToProps, {
  getPaymentFormulas,
  addPaymentFormulas,
  deletePaymentFormulas,
  patchPaymentFormulas,
  getPaymentFormulasForId,
})(PaymentFormulas);
